module.exports = __webpack_public_path__ + "static/media/aorb.e4a6f143.webp";


//////////////////
// WEBPACK FOOTER
// ./src/containers/StartPages/images/aorb.webp
// module id = 268
// module chunks = 1